import React from "react";

const ANNA_AVATAR = "https://images.unsplash.com/photo-1777927519810-5feb98777717?crop=entropy&cs=srgb&fm=jpg&q=85&w=120";
const SAM_AVATAR = "https://images.unsplash.com/photo-1656947296515-3faa76840890?crop=entropy&cs=srgb&fm=jpg&q=85&w=120";
const GREETED_KEY = "stealth_greeted";

const PRESENCE = {
  online: { label: "Online", dot: "bg-emerald-400" },
  listening: { label: "Listening…", dot: "bg-red-400 animate-pulse" },
  thinking: { label: "Thinking…", dot: "bg-amber-400 animate-pulse" },
  speaking: { label: "Speaking…", dot: "bg-mono-400 animate-pulse" },
  muted: { label: "Muted", dot: "bg-slate-500" },
};

export function presenceOf({ muted, speaking, thinking, listening }) {
  if (muted) return "muted";
  if (speaking) return "speaking";
  if (thinking) return "thinking";
  if (listening) return "listening";
  return "online";
}

export function PresencePill({ assistant, state }) {
  const p = PRESENCE[state] || PRESENCE.online;
  return (
    <div data-testid="assistant-presence" className="flex items-center gap-2 rounded-full glass-card pl-1 pr-3 py-1">
      <img src={assistant === "sam" ? SAM_AVATAR : ANNA_AVATAR} alt={assistant === "sam" ? "Sam" : "Anna"} className="w-6 h-6 rounded-full object-cover" />
      <span className="text-xs text-slate-200">{assistant === "sam" ? "Sam" : "Anna"}</span>
      <span className={`w-2 h-2 rounded-full ${p.dot}`} />
      <span data-testid="assistant-presence-status" className="text-[11px] uppercase tracking-wider text-slate-300">{p.label}</span>
    </div>
  );
}

const LINES = {
  anna: {
    morning: ["Hey {n}! Hope you slept well — what's on your mind this morning?", "Hi {n}! Fresh start to the day — I'm ready when you are."],
    afternoon: ["Hey {n}! How's your afternoon going?", "Hi {n}! Hope the day's treating you well — what can I help with?"],
    evening: ["Hey {n}! How was your day?", "Hi {n} — nice to see you this evening. What are we doing tonight?"],
    night: ["Hey {n}, up late? I'm here if you need anything.", "Still awake, {n}? Happy to help."],
  },
  sam: {
    morning: ["Hi {n}. What's first on the list this morning?", "Hey {n}. Early start — ready when you are."],
    afternoon: ["Hi {n}. What are we working on this afternoon?", "Hey {n}. How's the day going — what do you need?"],
    evening: ["Hi {n}. Anything to wrap up before the day ends?", "Hey {n}. Winding down, or one more thing tonight?"],
    night: ["Working late, {n}? I'm here.", "Late one, {n}. What can I take off your plate?"],
  },
};

function part(h) {
  if (h >= 5 && h < 12) return "morning";
  if (h >= 12 && h < 17) return "afternoon";
  if (h >= 17 && h < 22) return "evening";
  return "night";
}

export function buildGreeting(assistant, name, seed = 0) {
  const opts = LINES[assistant === "sam" ? "sam" : "anna"][part(new Date().getHours())];
  const line = opts[seed % opts.length];
  return name ? line.replaceAll("{n}", name) : line.replace(/,? \{n\}/g, "");
}

// Greet once per browser session (survives re-renders and new conversations).
let claimed = null;
export function claimSessionGreeting() {
  if (claimed !== null) return claimed;
  try {
    claimed = !sessionStorage.getItem(GREETED_KEY);
    sessionStorage.setItem(GREETED_KEY, "1");
  } catch { claimed = true; }
  return claimed;
}

export function GreetingBubble({ assistant, text }) {
  return (
    <div data-testid="assistant-greeting" className="mt-6 flex items-start gap-3 max-w-md fade-in-up">
      <img src={assistant === "sam" ? SAM_AVATAR : ANNA_AVATAR} alt={assistant === "sam" ? "Sam" : "Anna"} className="w-9 h-9 rounded-full object-cover border border-white/10" />
      <div className="rounded-2xl rounded-tl-sm px-4 py-2.5 text-[15px] text-slate-100 reading glass-card" data-testid="assistant-greeting-text">{text}</div>
    </div>
  );
}
